import React from "react";
import { useSelector } from "react-redux";
import {
  getThemeColor,
  getUserDetailsFromReducer,
} from "Store/reducers/Auth/AuthSlice";

const ShowActionButtons = () => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const themeColorString = useSelector(getThemeColor);
  let themeColor;

  try {
    themeColor = JSON.parse(themeColorString);
  } catch (error) {
    console.error(
      "Failed to parse themeColor in ShowActionButtons:",
      themeColorString,
      error
    );
    themeColor = {
      background: "#E6E6E6",
      text: "#333C4D",
      btnBg: "#ffffff",
      btnText: "#333C4D",
    };
  }

  const ActionLinks = userDetails?.action
    ? JSON.parse(userDetails?.action)
    : [];

  return (
    <div className="mt-4 sm:mt-6 lg:mt-7 grid grid-rows-1 gap-2 sm:gap-3 w-full">
      {ActionLinks?.map((button, index) => (
        <a
          href={button?.link}
          target="_blank"
          key={index}
          rel="noreferrer"
          className="animate-fade-slide-in"
        >
          <button
            className="px-3 py-2 sm:py-2.5 md:py-3 rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl text-sm sm:text-base md:text-lg font-medium transition-all duration-200 hover:opacity-90"
            style={{
              color: themeColor?.btnText,
              backgroundColor: themeColor?.btnBg,
            }}
          >
            {button?.name}
          </button>
        </a>
      ))}
    </div>
  );
};

export default ShowActionButtons;
